<template>
  <b-sidebar :visible="showReserva" @hidden="cerrar(sidebarCerrado)" :width="$store.getters['app/anchoSidebar']">

    <template #title>
      <h3>Datos de la reserva - <em>({{ reserva.codigo_confirmacion }})</em></h3>
    </template>

    <b-card header-class="d-flex justify-content-center flex-column align-items-center" class="mx-1" v-if="reserva.id">
      <template #header>
        <b-avatar :src="reserva.pasajero ? reserva.pasajero.avatar : ''" size="70px"></b-avatar>
        <!-- <b-badge :variant="$store.getters['reserva/getVariantStatus'](reserva.estatus)" size="sm" class="my-1">
          {{ $store.getters['reserva/getStatus'](reserva.estatus) }}
        </b-badge> -->
        <h3>{{ reserva.nombre }}</h3>
        <section>
          <font-awesome-icon icon="fas fa-users-line" />
          Adultos: {{ reserva.adultos }}
          <font-awesome-icon icon="fas fa-children" />
          Menores: {{ reserva.menores }}
          <font-awesome-icon icon="fas fa-baby" />
          Infantes: {{ reserva.infantes }}
        </section>
      </template>

      <section class="">
        <strong>Datos de la reserva</strong>
        <ul>
          <li>
            Código de confirmación: <em>{{ reserva.codigo_confirmacion }}</em>
          </li>
          <li>
            Costo Reserva: <em>{{ reserva.deposito | currency }}MXN</em>
          </li>
          <li>
            Cupón aplicado: <em>{{ reserva.total_promo | currency }}MXN ({{ reserva.promo_code ?? 'Sin cupón' }})</em>
          </li>
          <li>
            Depósito: <em>{{ reserva.deposito | currency }}MXN</em>
          </li>
          <li>
            Balance: <em>{{ reserva.balance | currency }}MXN</em>
          </li>

          <li>
            Fecha del tour: <em>{{ reserva.fecha | fecha }}</em>
          </li>
          <li>
            Fecha de creación de la reserva: <em>{{ reserva.created_at | fecha('lll') }}</em>
          </li>
          <li>
            Estatus de la reserva: <b-badge :variant="$store.getters['reserva/getVariantStatus'](reserva.estatus)">
              {{ $store.getters['reserva/getStatus'](reserva.estatus) }}
            </b-badge>
          </li>

          <li>
            Pick Up: <em>{{ reserva.pickup ? reserva.pickup.nombre : 'S/D' }} ({{ reserva.pickup? reserva.pickup.hora :
              'S/D' | fecha('LT A',true) }})</em>
          </li>

          <li> 
            Habitación: <em>{{ reserva.habitacion }}</em>
          </li>
          <li>
            Observación: <em>{{ reserva.observacion ?? 'S/D' }}</em>
          </li>

        </ul>
        <hr>

        <strong>Datos del Viajero</strong>
        <ul>
          <li>
            <font-awesome-icon icon="fas fa-envelope"></font-awesome-icon>
            Nombre: {{ reserva.nombre }}
          </li>
          <li>
            <font-awesome-icon icon="fas fa-percent" />
            Porcentaje de satisfacción: <em>{{ reserva.satisfaccion }}%</em>
          </li>
          <li>
            <font-awesome-icon icon="fas fa-envelope"></font-awesome-icon>
            Email: <a :href="`mailto:${reserva.email ? reserva.email : ''}`" target="_blank"
              :title="reserva.email ? reserva.email : ''">{{ reserva.email ? reserva.email : '' }}</a>
          </li>
          <li>
            <font-awesome-icon icon="fas fa-phone"></font-awesome-icon>
            Teléfono: <a :href="`tel:${reserva.telefono}`" :title="reserva.telefono">{{ reserva.telefono }}</a>
          </li>
          <li>
            <font-awesome-icon icon="fas fa-head-side-cough"></font-awesome-icon>
            Idioma: {{ ['Español','Ingles'][reserva.idioma - 1] }}
          </li>
          <li>
            <font-awesome-icon icon="fas fa-check"></font-awesome-icon>
            Términos aceptado: {{ reserva.terminos_aceptado ? 'Sí' : 'No' }}
          </li>

        </ul>

        <hr>
        <strong>Datos del Promotor Reservante</strong>
        <b-media vertical-align="center">

          <template #aside>
            <b-avatar :src="reserva.usuario ? reserva.usuario.avatar : ''" size="50px" />
          </template>

          <section class="d-flex flex-column">
            <article>
              Nombre:{{ reserva.usuario ? `${reserva.usuario.nombre} ${reserva.usuario.apellido}` : 'S/D' }}
            </article>

            <article>
              <font-awesome-icon icon="fas fa-envelope"></font-awesome-icon>
              Email: <a :href="`mailto:${reserva.usuario ? reserva.usuario.email : ''}`" target="_blank"
                :title="reserva.usuario ? reserva.usuario.email : ''">{{ reserva.usuario ? reserva.usuario.email :
                ''
                }}</a>
            </article>

            <article>
              <font-awesome-icon icon="fas fa-phone"></font-awesome-icon>
              Teléfono: <a :href="`tel:${reserva.usuario ? reserva.usuario.telefono : ''}`"
                :title="reserva.usuario ? reserva.usuario.telefono : ''">{{ reserva.usuario ?
                reserva.usuario.telefono :
                '' }}</a>
            </article>

            <article>
              Agencia:{{ reserva.agencia ? reserva.agencia.nombre : 'S/D' }}
            </article>
          </section>
        </b-media>
      </section>
      <hr>
      <strong v-if="reserva.agencia">Datos de la agencia</strong>
      <b-media vertical-align="center" v-if="reserva.agencia">
        <template #aside>
          <b-avatar :src="reserva.agencia ? reserva.agencia.logotipo : ''" size="60px" square />
        </template>
        <section class="d-flex flex-column">
          <article>
            Nombre:{{ reserva.agencia ? `${reserva.agencia.nombre}`: 'S/D' }}
          </article>

          <article v-show="reserva.agencia">
            <font-awesome-icon icon="fas fa-envelope"></font-awesome-icon>
            Email: <a :href="`mailto:${reserva.agencia ? reserva.agencia.email : 'S/D'}`" target="_blank"
              :title="reserva.agencia ? reserva.agencia.email : 'S/D'">{{ reserva.agencia ?
              reserva.agencia.email : 'S/D'
              }}</a>
          </article>

          <article v-show="reserva.agencia">
            <font-awesome-icon icon="fas fa-phone"></font-awesome-icon>
            Teléfono: <a :href="`tel:${reserva.agencia ? reserva.agencia.telefono : ''}`"
              :title="reserva.agencia ? reserva.agencia.telefono : 'S/D'">{{ reserva.agencia ?
              reserva.agencia.telefono :
              'S/D' }}</a>
          </article>

          <article v-show="reserva.agencia">
            <font-awesome-icon icon="fas fa-globe"></font-awesome-icon>
            Sítio web: <a :href="`tel:${reserva.agencia ? reserva.agencia.sitio_web : ''}`"
              :title="reserva.agencia ? reserva.agencia.sitio_web : 'S/D'">{{ reserva.agencia ?
              reserva.agencia.sitio_web :
              'S/D' }}</a>
          </article>



        </section>
      </b-media>
    </b-card>

  </b-sidebar>
</template>

<script>

import {
  BCard,
  BSidebar,
  BContainer,
  BRow,
  BCol,
  BButtonGroup,
  BButton,
  BFormGroup,
  BBadge,
  BAvatar,
  BMedia
} from 'bootstrap-vue';
import store from '@/store';
import {toRefs,ref,computed,onMounted,inject} from 'vue';

export default {

  components:{
    BCard,
    BSidebar,
    BContainer,
    BRow,
    BCol,
    BButtonGroup,
    BButton,
    BFormGroup,
    BBadge,
    BAvatar,
    BMedia

  },

  props:{
    showReserva:Boolean,
    actionsReserva:Function
  },

  model:{
    prop:'showReserva',
    event:'update:showReserva'
  },

  setup(props,{emit}){
    const {reserva} = toRefs(store.state.reserva);
    const {showReserva,actionsReserva} = toRefs(props)

    const {
      cerrar
    } = actionsReserva.value();

    const sidebarCerrado = () => {
      emit('')
    }

    return {
      loading:computed(() => store.state.loading),
      reserva,
      cerrar,
      sidebarCerrado,
    };
  },
}
</script>